import React, { useEffect, useState } from 'react';
import { ThemeProvider, CssBaseline, themeDesktop } from '@galaxy-ds/core';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { ChatContainer } from './chat';
import { AUTH_STORAGE_KEY } from '../constants';
import { useQueryStringToObject } from '../utils/use-query-string-to-object';
import { InformationContainer } from './info';
import styles from '../styles/theme-default.module.less';
import { Home } from './home';
import env from '../constants/env';
import { clarity } from 'react-microsoft-clarity';
import { Onboarding } from '../components/onboarding';
import { useSearchParams } from 'react-router-dom';

// Start seeing data on the Clarity dashboard with your id
clarity.init(env.CLARITY_PROJECT_ID);
clarity.consent();

const AppWrapper = () => {
  return (
    <Router>
      <RouteWrapper />

      {/* <ToastWrapper /> */}
    </Router>
  );
};

const RouteWrapper = () => {
  const [authenticated, setAuthenticated] = useState(false);
  // we want to fetch the query params if existing ?token and set it as a cookie
  const { token } = useQueryStringToObject<{ token: string }>();

  const navigate = useNavigate();
  const location = useLocation();

  // get query params for ?skipTour=true to skip the onboarding
  const [skipTourParams] = useSearchParams();
  const skipTour =
    skipTourParams.get('skipTour') === 'true' ||
    skipTourParams.get('skipTour') === '1';

  useEffect(() => {
    if (token) {
      // Using session storage because we don't want to persist the token across sessions
      window.sessionStorage.setItem(AUTH_STORAGE_KEY, token);
      
      // Keep existing query params except token
      const searchParams = new URLSearchParams(location.search);
      searchParams.delete('token');
      const queryString = searchParams.toString();
      const newPath = queryString
        ? `${location.pathname}?${queryString}`
        : location.pathname;
      
      navigate(newPath, { replace: true });
    }
  }, [location.pathname, location.search, token, navigate]);

  useEffect(() => {
    const token = window.sessionStorage.getItem(AUTH_STORAGE_KEY);
    if (token) {
      setAuthenticated(true);
    }
  }, []);
  
  return (
    <div className={styles.theme}>
      <ThemeProvider theme={themeDesktop}>
        <CssBaseline />
        {authenticated && !skipTour ? <Onboarding /> : null}
        {token && !authenticated ? (
          <div>Authenticating...</div>
        ) : !authenticated ? (
          <div>Not authenticated</div>
        ) : (
          <Routes>
            <Route path='/:id' element={<Home />} />
            <Route path='/:id/chat' element={<ChatContainer />} />
            <Route path='/:id/information' element={<InformationContainer />} />
            {/* if doesn't hit then we show div */}
            <Route path='*' element={<div>404</div>} />
          </Routes>
        )}
      </ThemeProvider>
    </div>
  );
};

export default AppWrapper;
